import { render, staticRenderFns } from "./gsggxq.vue?vue&type=template&id=b38978c0&scoped=true&"
import script from "./gsggxq.vue?vue&type=script&lang=js&"
export * from "./gsggxq.vue?vue&type=script&lang=js&"
import style0 from "./gsggxq.vue?vue&type=style&index=0&id=b38978c0&scoped=true&lang=css&"
import style1 from "./gsggxq.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38978c0",
  null
  
)

export default component.exports